import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { fetchUserDetailsThunk } from './user-reducer';

const UserDetailsComponent = () => {
  const dispatch = useDispatch();

  const fetchUserDetail = useCallback(() => {
    return dispatch(fetchUserDetailsThunk());
  }, [dispatch]);

  useEffect(() => {
    fetchUserDetail();
  }, []);

  return null;
};

export default UserDetailsComponent;
